import { Optional } from '@angular/core';
import { Component, Input, OnInit, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { TradeType } from '../../models';
import {TradingService} from '../../services/common/trading-service.service';
import { Account } from '../../models/common/trading-common.model';
import { AccountContextValue, CoreConstants, IContextService } from '@pershing/pershing-core';
@Component({
    selector: 'eligible-accounts-component',
    templateUrl: './eligible-accounts.component.html',
    styleUrls: ['./eligible-accounts.component.css']
})
export class  EligibleAccountsComponent implements OnInit{
    @Input() tradeType: TradeType;
    accounts: Account[];
    eligibleAccounts: Account[];
    userHasEligibleAccounts: boolean = false;
    ibdName: string = null ;
    ibdCustSupportPhone: string =  null ;
    showNoPhoneMessage: boolean = true;
    private onAccountListSub: Subscription;
    platform: string;
    constructor(public tradingService: TradingService, private contextService: IContextService,
                @Optional() @Inject('AppSettings') appSettings: any){
            if (appSettings) {
                this.platform = appSettings.platform;
                this.ibdName = appSettings.ibdConfigMap.ibdName;
                this.ibdCustSupportPhone = appSettings.ibdConfigMap.ibdCustSupportPhone;
           }
            if (!!this.ibdName && !!this.ibdCustSupportPhone) {
               this.showNoPhoneMessage = false;
            }
    }
    ngOnInit(): void {
        if (!!this.tradeType){
            this.fetchAccounts();
       }
    }

    fetchAccounts() {
        this.onAccountListSub = this.tradingService.onAccountListSubject$.subscribe((accountsList: Account[]) => this.onAccountList(accountsList));
        this.tradingService.getAccounts(this.platform);

    }
    onAccountList(accountsList: Account[]): void {
        if (accountsList) {
            this.accounts = accountsList;
            this.eligibleAccounts = this.setEligibleAccount();
            this.userHasEligibleAccounts = this.eligibleAccounts.length > 0;
        }

    }
    setEligibleAccount(): Account[]{
        switch (this.tradeType) {
            case TradeType.OPTION:
                return this.accounts.filter((account: Account) =>  account.optionFunctionCode !== '0' && account.tradingEnabled);
            case TradeType.PLAN_529FUND:
                return this.accounts.filter((account: Account) =>  account.trading529Enabled && account.tradingEnabled);
            default:
                return this.accounts.filter((account: Account) =>  !account.trading529Enabled && account.tradingEnabled);
            }
    }

    onSelect(selectedAccount: Account){
      if (!!selectedAccount) {
        let accountContextValue: AccountContextValue = new AccountContextValue(selectedAccount.acctNum);

        accountContextValue.accountNumber = selectedAccount.acctNum;
        accountContextValue.accountType = selectedAccount.acctType;
        this.contextService.setDomainContext(CoreConstants.ACCOUNT, accountContextValue);
      }
    }

}
